<template>
    <ns-loader
        class="out-of-layout"
        :toLoad="toLoad"
        :fetchTimer="5000"
        @dataFetched="onDataFetched"

        ref="nsLoader"
    >
        <div
            slot="loader"
            class="dark-loading"
            style="width: 100%; height: calc(100vh - 64px);"
        >
            <div style="text-align: center;">
                <v-progress-circular
                    color="info"
                    indeterminate
                    :size="50"
                ></v-progress-circular>
                <div style="color: #1876d2;font-weight: bold;">{{$t('instance.index.loading_text')}}</div>
            </div>
        </div>
        <v-tabs
            v-model="tab"
            dark
            slot="content"
        >
            <v-tab 
                ripple
            >
                {{$t('instance.index.tab_instances')}}
            </v-tab>
            <v-tooltip bottom :disabled="disableModelisationAccess === false">
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-tab 
                            ripple 
                            :disabled="disableModelisationAccess" 
                            class="data-models-tab"
                        >
                            {{$t('instance.index.tab_datamodel')}}
                        </v-tab>
                    </div>
                </template>
                <span>{{$t('instance.index.wait_deployment_message')}}</span>
            </v-tooltip>
            <v-tooltip bottom :disabled="disableModelisationAccess === false">
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-tab 
                            ripple 
                            :disabled="disableModelisationAccess" 
                            class="data-models-tab"
                        >
                            {{$t('instance.index.tab_permlissions')}}
                        </v-tab>
                    </div>
                </template>
                <span>{{$t('instance.index.wait_deployment_message')}}</span>
            </v-tooltip>
            <v-tooltip bottom :disabled="disableModelisationAccess === false">
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-tab 
                            ripple 
                            :disabled="disableModelisationAccess" 
                            class="data-models-tab"
                        >
                            {{$t('instance.index.tab_queries')}}
                        </v-tab>
                    </div>
                </template>
                <span>{{$t('instance.index.wait_deployment_message')}}</span>
            </v-tooltip>
            <template>
                <div class="concrete-documentation">
                    <a 
                        :disabled="disableModelisationAccess" 
                        class="data-models-tab--link" 
                        target="_blank" 
                        :href="concreteDocumentationLink"
                    >
                        {{$t('instance.index.documentation_link')}}
                    </a>
                </div>
            </template>

            <v-tab-item class="item-content">
                <instance-details
                    v-if="displayInstanceDetails"
                    ref="instance-details-content"
                    :instance="selectedInstance"
                    :modelisations="modelisations"
                >
                </instance-details>
                <instance-list
                    v-else
                    @triggerRefresh="triggerRefresh"
                    :instances="instances"
                    :modelisations="modelisations"
                ></instance-list>
            </v-tab-item>
            <v-tab-item>
                <data-model
                    :modelisations="modelisations"
                    :schema="schemaModelisation"
                    :selected-modelisation="selectedModelisation"
                    ref="data-model"
                    @update-schema-modelisation="updateSchemaModelisation"
                ></data-model>
            </v-tab-item>
            <v-tab-item>
                <permissions
                    :schema="schemaModelisation"
                    :modelisations="modelisations"
                    :selected-modelisation="selectedModelisation"
                    :latest-modelisation="latestModelisation"
                    @update-schema-modelisation="updateSchemaModelisation"
                    @triggerRefresh="triggerRefresh"
                ></permissions>
            </v-tab-item>
            <v-tab-item>
                <query-fields
                    :modelisations="modelisations"
                    :schema="schemaModelisation"
                    :selected-modelisation="selectedModelisation"
                    @update-schema-modelisation="updateSchemaModelisation"
                ></query-fields>
            </v-tab-item>
        </v-tabs>
    </ns-loader>
</template>
<script>
import InstanceList from './InstanceList/index.vue';
import DataModel from './DataModel/index.vue';
import Permissions from './Permissions/index.vue';
import QueryFields from './QueryFields/index.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import EventBus from '@/eventBus.js';
import SchemaModelisation from './DataModel/schema-modelisation.js';
import InstanceDetails from '@/components/page/Instance/InstanceDetails';
import {
    mapGetters
} from 'vuex';
export default {
    components: {
        InstanceList,
        DataModel,
        Permissions,
        NsLoader,
        QueryFields,
        InstanceDetails
    },
    props: {},
    data() {
        return {
            activeTab: 0,
            instances: [],
            modelisations: [],
            deploymentRequests: [],
            schemaModelisation: {},
            displayInstanceDetails: false,
            selectedInstance: {},
        };
    },
    computed: {
        ...mapGetters([
            'getCurrentApplication',
            'getCurrentApplicationTab'
        ]),
        disableModelisationAccess() {
            return this.deploymentRequests.find(deploymentRequest => deploymentRequest.modelisation_uid === this.modelisations[0].uid) !== undefined;
        },
        toLoad () {

            return [
                {
                    model: 'instances',
                    name: 'instances',
                    filters: {
                        archived: false,
                        application: this.$route.params.applicationUid,
                        c_resp_nested: true,
                    },
                },
                {
                    model: 'modelisations',
                    name: 'modelisations',
                    filters: {
                        application: this.$route.params.applicationUid,
                    },
                },
                {
                    model: 'deploymentRequests',
                    name: 'deploymentRequests',
                    filters: {
                        status__in: 'PENDING,RUNNING',
                        application: this.$route.params.applicationUid,
                    },
                },
            ];
        },

        latestModelisation() {
            return this.modelisations.find((modelisation) => modelisation.editable === true) || {};
        },
        selectedModelisation(){
            // Used to sync schema version in timeline for each tabs
            if(this.schemaModelisation.version){
                return this.modelisations.find((modelisation) => modelisation.version === this.schemaModelisation.version);
            }
            return this.latestModelisation;
        },
        concreteDocumentationLink(){
            return window.config.concrete_documentation;
        },
        //Save currentTab in sessionStorage to return to currentTab on page reload
        tab:{
            set(newVal) {
                sessionStorage.setItem('currentTab', parseInt(newVal));
                this.$store.commit('SET_CURRENT_APPLICATION_TAB', newVal);
            },
            get () {
                return this.$store.state.currentApplicationTab;
            }
        }
    },
    watch: {
        '$store.getters.modelsHasErrors': {
            handler (modelsHasErrors){
                if(modelsHasErrors){
                    this.$store.commit('SET_SAVE_STATE', 'error');
                }else{
                    if(this.schemaModelisation.hasUnsavedChange()){
                        this.$store.commit('SET_SAVE_STATE', 'unsaved');
                    }else{
                        this.$store.commit('SET_SAVE_STATE', 'upToDate');
                    }
                }
            },
            deep: true,
        },
    },
    beforeCreate (){
        if (this.$store.getters.currentApplicationEmpty) {
            this.$store.dispatch('remoteGet',
                {
                    url: `application/${this.$route.params.applicationUid}`
                })
                .then((res)=>{
                    this.$store.commit('SET_CURRENT_APPLICATION', res.data);
                }).catch(()=>{
                    this.$router.push({
                        name: 'application-list'
                    });
                });
        }
    },
    mounted() {
        // if session storage is empty we set current tab to default tab (instance)
        if(isNaN(this.$store.state.currentApplicationTab)){
            sessionStorage.setItem('currentTab', parseInt(this.activeTab));
            this.$store.commit('SET_CURRENT_APPLICATION_TAB', this.activeTab);
        }
        EventBus.$on('reload-ns-loader', () => {
            if(this.$refs.nsLoader) this.$refs.nsLoader.triggerRefresh();
        });
        EventBus.$on('open-instance-details', (selectedInstance) => {
            this.selectedInstance = selectedInstance;
            this.displayInstanceDetails = true;
        });
        EventBus.$on('close-instance-details', () =>{
            this.displayInstanceDetails = false;
            if(this.$refs.nsLoader){
                this.$refs.nsLoader.triggerRefresh()
            }
        });
    },
    destroyed (){
        EventBus.$off('reload-ns-loader');
        EventBus.$off('open-instance-details', () =>{
            this.displayInstanceDetails = false;
        });
    },
    async beforeRouteLeave (to, from, next){
        // we set current tab to default tab (instance) when leaving the route
        sessionStorage.setItem('currentTab', parseInt(this.activeTab));
        this.$store.commit('SET_CURRENT_APPLICATION_TAB', this.activeTab);

        if(this.$store.getters.currentApplicationEmpty) next();
        else if(this.$refs['data-model']) next(await this.$refs['data-model'].checkForNavigate());
        else next();
    },
    methods: {
        onDataFetched(res) {
            this.$store.dispatch('fundation/updateArrayOfItems', {
                srcArray: this.instances,
                targetArray: res.instances
            });
            this.instances.sort((a,b) => {
                return new Date(b.creation_date) - new Date(a.creation_date);
            });
            // TODO sort instance by creation date
            this.$store.dispatch('fundation/updateArrayOfItems', {
                srcArray: this.modelisations,
                targetArray: res.modelisations
            });
            this.$store.dispatch('fundation/updateArrayOfItems', {
                srcArray: this.deploymentRequests,
                targetArray: res.deploymentRequests
            });
            /*
                Related to vuetify 2.6 migration :
                We need to set this.schemaModelisation to prevent
                an error in init() in Permissions page causing first v-if
                to be never true.
            */
            if(Object.keys(this.schemaModelisation).length === 0){
                this.$nextTick(()=>{
                    this.setSchemaModelisation(this.latestModelisation);
                })
            }
        },
        triggerRefresh() {
            this.$refs.nsLoader.triggerRefresh(false);
        },
        setSchemaModelisation(modelisation){
            this.updateSchemaModelisation(modelisation.value, modelisation.version)
        },
        updateSchemaModelisation (value, version){
            this.$set(this, 'schemaModelisation', new SchemaModelisation(value, this.$store.getters.listRelDatatype, version));
            if(this.latestModelisation.version !== version){
                this.$store.commit('SET_SAVE_STATE', 'readOnly');
            }else{
                this.$store.commit('SET_SAVE_STATE', 'upToDate');
            }
        },
    },
};

</script>
<style lang="scss">
.out-of-layout{
    position: absolute !important;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #303030;
}

.v-tab:hover{
    color: #82b1ff;
}
.data-models-tab {
    height: 100% !important;
    &--link{
        align-items: center;
        display: inline-flex;
        flex: 0 1 auto;
        font-size: 14px;
        font-weight: 500;
        line-height: normal;
        height: inherit;
        max-width: 264px;
        text-align: center;
        text-transform: uppercase;
        vertical-align: middle;
        height: 100%;
        opacity: .7
    }
}

.concrete-documentation a{
    color: #ffffff;
}

.concrete-documentation a:hover{
    color: #82b1ff;
}
.item-content{
    height: 100vh
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/index.vue